import { createStyles, makeStyles } from '@material-ui/core';

export const useSelectDropdownDividerStyles = makeStyles(() =>
    createStyles({
        root: {
            height: 1,
            width: '100%',
            margin: '4px 0px',
            backgroundColor: '#D4D4D4'
        }
    })
);
